import { render } from "./design_2_block.vue?vue&type=template&id=666b95dd&scoped=true"
import script from "./design_2_block.vue?vue&type=script&lang=js"
export * from "./design_2_block.vue?vue&type=script&lang=js"

import "./design_2_block.vue?vue&type=style&index=0&id=666b95dd&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b95dd"]])

export default __exports__